import script from "./appletsCoupon.vue?vue&type=script&lang=ts&setup=true"
export * from "./appletsCoupon.vue?vue&type=script&lang=ts&setup=true"

import "./appletsCoupon.vue?vue&type=style&index=0&id=6afe11a8&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afe11a8"]])

export default __exports__